<nav mat-tab-nav-bar #tabGroup>
  <ng-container *ngIf="!isLoading; else loading">
    <div
      mat-tab-link
      *ngFor="let view of views; let index = index; trackBy: trackNavItem"
      [routerLink]="[view.name, view.id]"
      routerLinkActive="active"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: true }"
      [active]="rla.isActive"
    >
      <div
        (cdkDropListDropped)="onDropTab($event)"
        [cdkDropListConnectedTo]="(childMenuIds$ | async)!"
        [id]="view.id + '__' + index"
        cdkDropListOrientation="horizontal"
        class="child-menu-drop-list"
        cdkDropList
      >
        <div
          (cdkDragEntered)="onDragEntered($event)"
          (cdkDragExited)="onDragExited($event)"
          class="dragon"
          cdkDrag
        >
          <div *cdkDragPlaceholder class="drag-custom-placeholder"></div>
          <div class="drag-wrapper">
            <div class="drag-wrapper-content">
              <sn-icon cdkDragHandle class="draggable">drag_indicator</sn-icon>
              <div class="view-name">{{ view.name }}</div>
              <button
                mat-icon-button
                *ngIf="canDelete || canChange"
                class="menu"
                [matTooltip]="'dashboard.operational.tabs.viewOptions' | t"
                matTooltipPosition="above"
                [matMenuTriggerFor]="viewOptionsMenu"
                (click)="$event.stopPropagation()"
              >
                <sn-icon>more_vert</sn-icon>
              </button>
              <mat-menu #viewOptionsMenu="matMenu">
                <button *ngIf="canChange" mat-menu-item (click)="editView(view)">
                  <sn-icon fontSet="fal" fontIcon="fa-pen"></sn-icon>
                  <span>{{ 'common.editView' | t }}</span>
                </button>
                <button *ngIf="canDelete" mat-menu-item (click)="deleteView(view, index)">
                  <sn-icon fontSet="fal" fontIcon="fa-trash-alt"></sn-icon>
                  <span>{{ 'dashboard.operational.tabs.deleteView' | t }}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nav>

<ng-template [ngIf]="views.length && !isLoading" [ngIfThen]="viewWidgets"></ng-template>
<ng-template [ngIf]="!views.length && !isLoading" [ngIfThen]="empty"></ng-template>
<ng-template [ngIf]="isLoading" [ngIfThen]="loading"></ng-template>

<ng-template #loading>
  <mat-progress-spinner color="accent" diameter="32" mode="indeterminate"></mat-progress-spinner>
</ng-template>

<ng-template #viewWidgets>
  <router-outlet></router-outlet>
</ng-template>

<ng-template #empty>
  <sn-empty-state class="emptyTmpl" icon="cancel_presentation" [title]="'dashboard.operational.tabs.noViewsFound' | t">
    <button mat-flat-button *ngIf="canAdd" color="accent" (click)="addView()">{{ 'common.addView' | t }}</button>
  </sn-empty-state>
</ng-template>
